$(document).on('shown.bs.modal', '#change-delivery-modal', function () {
  var sel = document.getElementById('change-delivery-select');
  if (!sel) return;
  updateChangeDeliveryPlaceGroup(sel);
});

$(document).on('changed.bs.select change', '#change-delivery-select', function () {
  updateChangeDeliveryPlaceGroup(this);
});

$(document).on('input', '#change-delivery-place-text', function () {
  var term = this.value.trim();
  var sel = document.getElementById('change-delivery-select');
  var deliveryMap = JSON.parse(sel.getAttribute('data-delivery-map') || '{}');
  var deliveryId = deliveryMap[sel.value];
  var results = document.getElementById('change-delivery-place-results');
  var placeId = document.getElementById('change-delivery-place-id');

  clearTimeout(window._cdmSearchTimer);
  if (term.length < 2) {
    results.style.display = 'none';
    return;
  }

  window._cdmSearchTimer = setTimeout(function () {
    $.getJSON('/document_items/autocomplete_place_name', { delivery_id: deliveryId, term: term }, function (data) {
      results.innerHTML = '';
      if (data.length === 0) {
        results.style.display = 'none';
        return;
      }
      data.forEach(function (item) {
        var li = document.createElement('li');
        li.className = 'list-group-item list-group-item-action p-1 small';
        li.style.cursor = 'pointer';
        li.textContent = item.label;
        li.addEventListener('mousedown', function (e) {
          e.preventDefault();
          document.getElementById('change-delivery-place-text').value = item.value;
          placeId.value = item.id;
          results.style.display = 'none';
        });
        results.appendChild(li);
      });
      results.style.display = 'block';
    });
  }, 250);
});

$(document).on('blur', '#change-delivery-place-text', function () {
  setTimeout(function () {
    var results = document.getElementById('change-delivery-place-results');
    if (results) results.style.display = 'none';
  }, 200);
});

function updateChangeDeliveryPlaceGroup(sel) {
  var deliveryMap = JSON.parse(sel.getAttribute('data-delivery-map') || '{}');
  var withPlaces = JSON.parse(sel.getAttribute('data-deliveries-with-places') || '[]');
  var deliveryId = deliveryMap[sel.value];
  var group = document.getElementById('change-delivery-place-group');
  var placeText = document.getElementById('change-delivery-place-text');
  var placeId = document.getElementById('change-delivery-place-id');
  var results = document.getElementById('change-delivery-place-results');

  if (!group) return;

  if (withPlaces.indexOf(parseInt(deliveryId, 10)) !== -1) {
    group.style.display = 'block';
  } else {
    group.style.display = 'none';
    if (placeText) placeText.value = '';
    if (placeId) placeId.value = '';
    if (results) results.style.display = 'none';
  }
}
